import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  loader: {
    display: 'block',
    marginLeft: 10,
  },
  title: {
    marginBottom: 20,
    fontSize: 16,
    fontWeight: 600,
    color: theme.custom.darkBlue,
  },
  rejectBtn: {
    marginRight: 20,
  },
}));
